const round = (num, places = 0) => {
  const mult = 10 ** places;
  return Math.round(num * mult) / mult;
};

const init = () => ({
  r: round,
});

module.exports = init;
